import type { VideoData, VideoParser } from './video';
import { InvalidVideo } from './videoErrors';

const isValidUrl = (url: string) => {
  const regex = /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|embed\/)[\w-]+|youtu\.be\/[\w-]+)(\?.*)?$/;
  return regex.test(url);
};

const getContentData = async (url: string): Promise<VideoData> => {
  const videoId = getVideoId(url);
  const metadata = await getMetadataFromVideoId(videoId);

  return {
    type: 'youtube',
    title: metadata.title,
    author: metadata.author_name,
    thumbnail: metadata.thumbnail_url,
    videoId,
  };
};

const getVideoId = (url: string) => {
  const match = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]{11})(?:\?|&|$)/);
  if (!match) {
    throw new Error('Could not extract video ID from YouTube URL');
  }

  return match[1];
};

const getMetadataFromVideoId = async (id: string) => {
  const urlShort = `https://youtu.be/${id}`;
  const apiUrl = `https://www.youtube.com/oembed?url=${encodeURIComponent(urlShort)}&format=json`;

  try {
    const response = await fetch(apiUrl);
    if (!response.ok) throw new InvalidVideo();

    return await response.json();
  } catch (error) {
    throw new InvalidVideo();
  }
};

export const youtubeVideo: VideoParser = {
  isValidUrl,
  getContentData,
};
